import { isDefined } from "./filters";

export function withOnlyDefinedProperties<T extends Record<string, any> | undefined>(obj: T): Partial<T> | undefined {
  if (!obj) return undefined;
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => isDefined(value))) as Partial<T>;
}
